import { Stack } from "@mui/material";
import { MprcRequestErrorReport, MprcRequestIndicator } from "components";
import { ChooseLandingPageOptions } from "generated/CoreApi_v1";
import { useCoreApi } from "providers/CoreApiProvider";
import React, { useEffect, useState } from "react";

interface IProps {
    landingPage: ChooseLandingPageOptions;
}

const PerformaIntegration: React.FC<IProps> = ({ landingPage }) => {
    const api = useCoreApi();
    const [loading, setLoading] = useState<boolean>(true);
    const [viewError, setViewError] = useState<any>(null);
    const [url, setUrl] = useState<string | null>(null);

    const loadData = async () => {
        setLoading(true);
        setViewError(null);

        try {
            var response = await api.v1.integration.performaChooseLandingpage({ landingPage });
            setUrl(response.data.url);
        }
        catch (e) {
            setViewError(e);
        }
        finally {
            setLoading(false);
        }
    };


    useEffect(() => {
        loadData();
    }, [landingPage]);

    return loading
        ? <MprcRequestIndicator type="waiting" />
        : viewError == null
            ? <iframe title="Performa" src={url!} height={"100%"} width={"100%"} style={{ border: 0 }} sandbox="allow-forms allow-scripts allow-same-origin  allow-top-navigation-by-user-activation allow-downloads"></iframe>
            : (
                <Stack id="message" height="100%" justifyContent="center" alignItems="center" >
                    <MprcRequestErrorReport error={viewError} />
                </Stack>
            );
};

export default PerformaIntegration;
